import isString from './_isString';
import template from './_template';

export { isString, template };
